export default "__VITE_ASSET__CzJImcSp__"